import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { NAME } from '#client/build-env';
import { ACCOUNT_TYPES } from '#client/constants/accountTypes';
import { ENABLE_ENTERPRISE_DASHBOARD } from '#client/constants/experimentsFlags';
import { useAccountExperience } from '#client/hooks/useAccountExperience';
import { EnterpriseHome, HomeGateway } from '#client/pages';

function CustomerRouterInner() {
  const { accountExperience, enterprise, loading } = useAccountExperience();
  const isEnterprise = accountExperience.accountType === ACCOUNT_TYPES.ENTERPRISE;
  const isEnterpriseDashboardEnabled = useExperimentFlag(ENABLE_ENTERPRISE_DASHBOARD, false);

  if (loading) {
    return <PageLoading />;
  }

  if (isEnterprise && isEnterpriseDashboardEnabled) {
    return <EnterpriseHome enterprise={enterprise} />;
  }

  return <HomeGateway />;
}

export default function CustomerRouter() {
  return (
    <ErrorBoundary fallback={<PageError />} id={`${NAME}/App/CustomerRouter`}>
      <CustomerRouterInner />
    </ErrorBoundary>
  );
}
